import { RootState } from '../../types';

export const stats = (state: RootState) => state.app.stats;
